<template>
  <div id="audience">
    <audience-form :audience="audience" v-if="audience" @edit-successful="editSuccessful" @edit-fail="editFail">
    </audience-form>
    <div class="row">
      <button :class="`btn btn-${btnClass}`" style="margin:auto;" @click="editAudience">
        <div v-if="isEditing">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span class="sr-only">Loading...</span>
        </div>
        <span v-else>
          {{ btnText }}
        </span>
      </button>
    </div>
    <div v-if="countFunction()">
      <div class="h4 mt-5 text-center">
        Parameters That Have Value For This Audience
      </div>
      <ul class="list-group" v-for="(parameter, index) in audiencesParameters" :key="index">
        <li class="list-group-item rounded-sm mt-2" >
          <div class="custom-control custom-checkbox">
            <input class="form-check-input"  type="checkbox"  v-on:click="toggleList(parameter.id, parameter.key)" :checked="parameterIdsToBeDefaulted.includes(parameter.id)">
            <label  style="color:black" >{{ parameter.key }}</label>
            <Tooltip v-if="parameter.audience_values[$route.params.id] === parameter.default_value" :content="'Same as default'"></Tooltip>
            <i class="fas fa-external-link redirect-icon" @click="$router.push({ name: 'Parameter', params: { id: parameter.id } })"></i>
          </div>
        </li>
      </ul>
      <div class="text-center mt-3">
        <button class="btn btn-warning" @click="changeToDefault">Set Default Values to Selected Parameters</button>
        <button class="btn btn-primary ml-2" @click="createTemplateFromAudience">Create Template From This Audience</button>
      </div>
    </div>

  </div>
</template>

<script>
import AudienceForm from '../components/AudienceForm'
import Tooltip from '../components/common/Tooltip.vue';
import { audienceParameters } from '../util/templateFromAudience';
export default {
  data() {
    return {
      isEditing: false,
      btnClass: "primary",
      btnText: "Edit Audience",
      parameterIdsToBeDefaulted: [],
      parameterKeysToBeDefaulted: []
    }
  },
  computed: {
    audience() {
      return this.$store.getters.audiences.find(item => item.id == this.$route.params.id)
    },
    audiencesParameters() {
      return audienceParameters(this.$store.getters.parameters, this.$route.params.id)
    }
  },
  methods: {
    countFunction() {
      const result = this.audiencesParameters.length > 0 ? true : false
      return result
    },
    toggleList(id, key) {
      // if id exists remove it 
      const indexOfId = this.parameterIdsToBeDefaulted.indexOf(id)
      if (indexOfId > -1) {
        this.parameterIdsToBeDefaulted.splice(indexOfId, 1);
        this.parameterKeysToBeDefaulted.splice(indexOfId, 1);
      }
      else {
        this.parameterIdsToBeDefaulted.push(id)
        this.parameterKeysToBeDefaulted.push(key)
      }
      // if not exists push it
    },
    changeToDefault() {
      let confirmClause = this.parameterKeysToBeDefaulted.join(", ")
      let isSure = confirm(`Parameters with keys ${confirmClause} will be set to default, are you sure?`)
      if (isSure) {
        this.audiencesParameters.forEach(parameter => {
          if (this.parameterIdsToBeDefaulted.includes(parameter.id)) {
            const data = {
              ...parameter,
              audience_values: { ...parameter.audience_values ?? parameter.audience_values },
            };
            const id = data.id;
            delete data.id;
            data.audience_values[this.$route.params.id] = data.default_value;
            this.$store.dispatch("configEdit", { type: 'parameter', payload: { id, data } });
          }
        })
      }
      this.parameterIdsToBeDefaulted = []
      this.parameterKeysToBeDefaulted = []
    },
    createTemplateFromAudience() {
      // One-shot hand-off: the new-template form reads the id back off the query and prefills
      // itself from the store, so there is no Vuex field to keep in sync or clean up.
      this.$router.push({
        name: 'template-new',
        params: { aid: this.$route.params.aid },
        query: { fromAudience: this.$route.params.id }
      })
    },
    editAudience() {
      const experiments = this.$store.getters.experiments;
      const messages = this.$store.getters.activeAutomatedMessages;
      let messageNames = ""
      if (messages) {
        messages.forEach(message => {
          const messageName = message.name
          message.audience.includedAudience.forEach(included => {
            if (included.id === this.audience.id) messageNames += messageName + ", "
          })
          message.audience.excludedAudience.forEach(excluded => {
            if (excluded.id === this.audience.id) messageNames += messageName + ", "
          })
        })
        if (messageNames.length > 0) {
          const confirmMessage = `You will edit an audience that is actively used in  ${messageNames} message/s, Are you sure?`
          if (!confirm(confirmMessage)) return;
        }
        this.isEditing = true
        this.btnClass = "primary"
        this.$emit('editAudience')
      }

      if (experiments) {
        const includedExperiments = experiments.filter(experiment => {
          return ((experiment.status == "started" || experiment.status == "created") && !experiment.audience.localeCompare(this.audience.id))
        })
        if (includedExperiments.length > 0) {
          let experimentNames = ""
          includedExperiments.forEach(experiment => {
            experimentNames += experiment.name + ", "
          })
          experimentNames = experimentNames.slice(0, -2)
          if (confirm(`You will edit an audience that is actively used in ${experimentNames} experiment/s, it may break the experiment. Are you sure?`)) {
            this.isEditing = true
            this.btnClass = "primary"
            this.$emit('editAudience')
          }
          else return;
        }
        else {
          this.isEditing = true
          this.btnClass = "primary"
          this.$emit('editAudience')
        }
      }
      else {
        this.isEditing = true
        this.btnClass = "primary"
        this.$emit('editAudience')
      }
    },
    editSuccessful() {
      this.isEditing = false
      this.btnClass = "success"
      this.btnText = "Edited!"
    },
    editFail() {
      this.isEditing = false
      this.btnClass = "danger"
      this.btnText = "Error!"
    }
  },
  watch:{
    parameterIdsToBeDefaulted(newValue){
        console.log(newValue)
      }
    }
  ,
  components: {
    AudienceForm,
    Tooltip
  }
}
</script>

<style scoped>
label{
  margin-bottom: 0;
}
#audience {
  padding: 20px;
  border-radius: 10px;
  background-color: #fff;
}

.list-group-item{
  border-color: black;
  padding: 5px;
}

.redirect-icon{
  margin-inline: 1rem; 
  color: black; 
  cursor: pointer;
}
</style>